// import { Form, Input, Select } from 'antd';
// import React, { useEffect, useRef, useState } from 'react'
// import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
// import AccountService from '../../../../../Services/AccountService';
// import UserService from '../../../../../Services/UserService';
// import ClinicService from '../../../../../Services/ClinicService';
// import { convertUTCDate } from '../../../../../utils/convertionFunc';
// import { useDispatch, useSelector } from 'react-redux';
// import { handleSetPatientRegistrationPayload } from '../../../../../Redux/actions/patientActions';
// import { debounce } from 'lodash';

// function RpmDetails({ handleCancel, handleNext, handlePrevious, currPageView }) {
//     const [usersList, setUsersList] = useState([]);
//     const [accountList, setAccountList] = useState([]);
//     const [clinicList, setClinicList] = useState([]);
//     const [selectedClinic, setSelectedClinic] = useState(null);
//     const [selectedAcc, setSelectedAcc] = useState(null);
//     const [selectedDoc, setSelectedDoc] = useState(null);
//     const history = useHistory();
//     const formRef = useRef();
//     const dispatch = useDispatch();
//     const { registrationPayload, selectedEditPatient } = useSelector((state) => state.patients);
//     const loggedUserObj = sessionStorage.getItem('login_result');
//     const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;
//      const debouncedGetUsers = useRef(
//           debounce((payload) => {
//             getUsersList(payload);
//           }, 300)
//         ).current;

//     useEffect(() => {
//         if (selectedEditPatient && !selectedAcc && !selectedClinic) {
//             if (selectedEditPatient.hospitalId) {
//                 setSelectedAcc({ account_Id: selectedEditPatient.hospitalId });
//                 getSpecificAccount({ account_Id: selectedEditPatient.hospitalId });
//             }
//             if (selectedEditPatient.hospitalId && selectedEditPatient.locationId) {
//                 fetchSpecificClinic({ account_Id: selectedEditPatient.hospitalId, clinic_Id: selectedEditPatient.locationId });
//                 setSelectedClinic({ account_Id: selectedEditPatient.hospitalId, clinic_Id: selectedEditPatient.locationId });
//                 if (selectedEditPatient.providerCode) {
//                     fetchSpecificUser({ account_Id: selectedEditPatient.hospitalId, clinic_Id: selectedEditPatient.locationId, userId: selectedEditPatient?.providerCode });
//                     setSelectedDoc({ account_Id: selectedClinic?.account_Id, clinic_Id: selectedClinic?.clinic_Id, userId: selectedEditPatient?.providerCode });
//                 }
//             }
//             formRef.current.setFieldsValue({
//                 hospitalId: selectedEditPatient.hospitalId,
//                 locationId: selectedEditPatient.locationId,
//                 userId: selectedEditPatient.providerCode,
//                 uhId: selectedEditPatient.uhId
//             });
//         }
//     }, [selectedEditPatient]);

//     useEffect(() => {
//         if (!loggedUser) {
//             return history.push('/');
//         }
//         getAccountList(null);
//     }, []);

//     useEffect(() => {
//         if (selectedAcc) {
//             fetchClinicList();
//         }
//     }, [selectedAcc]);

//     useEffect(() => {
//         if (selectedAcc && selectedClinic) {
//             const seleAccDocPayload = {
//                 account_Id: selectedAcc.account_Id,
//                 clinic_Id: selectedClinic.clinic_Id
//             }
//             getUsersList(seleAccDocPayload);
//         }

//     }, [selectedAcc, selectedClinic]);

//     const getAccountList = async (filterPayload) => {
//         let payload = { pageNo: 1, accountRoleType: 'clinic' }
//         let finalPayload;

//         if ((loggedUser?.user?.rolecode === "ACCT_ADM") || (loggedUser?.user?.rolecode === "CLINIC_ADM")) {
//             payload.account_Id = loggedUser?.user?.account_Id;
//         }

//         if (filterPayload) {
//             finalPayload = {
//                 ...payload,
//                 ...filterPayload
//             }
//         }

//         try {
//             const response = await AccountService.AccountList(filterPayload ? finalPayload : payload);
//             setAccountList(response.data);
//             if ((loggedUser?.user?.rolecode === "ACCT_ADM") || (loggedUser?.user?.rolecode === "CLINIC_ADM")) {
//                 setSelectedAcc(response.data[0]);
//                 // if (loggedUser?.user?.rolecode === "CLINIC_ADM") {
//                 //     fetchClinicList();
//                 // }
//             }
//         }
//         catch (error) {
//             console.log(error);
//         }

//     };

//     const getSpecificAccount = async (filterPayload) => {
//         let payload = { pageNo: 1, accountRoleType: 'clinic' }
//         let finalPayload;

//         // if ((loggedUser?.user?.rolecode === "ACCT_ADM") || (loggedUser?.user?.rolecode === "CLINIC_ADM")) {
//         //     payload.account_Id = loggedUser?.user?.account_Id;
//         // }

//         if (filterPayload) {
//             finalPayload = {
//                 ...payload,
//                 ...filterPayload
//             }
//         }

//         try {
//             const response = await AccountService.AccountList(filterPayload ? finalPayload : payload);
//             setAccountList(response.data);
//             if ((loggedUser?.user?.rolecode === "ACCT_ADM") || (loggedUser?.user?.rolecode === "CLINIC_ADM")) {
//                 setSelectedAcc(response.data[0]);
//                 // if (loggedUser?.user?.rolecode === "CLINIC_ADM") {
//                 //     fetchClinicList();
//                 // }
//             }
//         }
//         catch (error) {
//             console.log(error);
//         }

//     };

//     const getUsersList = async (filterVal) => {

//         const userPayload = { pageNo: '1',userType:'P' };
//         if (loggedUser?.user?.rolecode === "ACCT_ADM") {
//             userPayload.account_Id = loggedUser.user.account_Id;
//         }
//         else if (loggedUser?.user?.rolecode === "CLINIC_ADM") {
//             userPayload.account_Id = loggedUser.user.account_Id;
//             userPayload.clinic_Id = loggedUser.user.clinic_Id;
//         }
//         let finalPayload;
//         if (filterVal) {
//             finalPayload = {
//                 ...userPayload,
//                 ...filterVal
//             }
//         }

//         try {
//             const response = await UserService.getUser(filterVal ? finalPayload : userPayload);
//             setUsersList(response.data);
//         }
//         catch (e) {
//             console.log(e);
//         }


//     };

//     const fetchSpecificUser = async (filterVal) => {

//         const userPayload = { pageNo: '1' };

//         // if (loggedUser?.user?.rolecode === "ACCT_ADM") {
//         //     userPayload.account_Id = loggedUser.user.account_Id;
//         // }
//         // else if (loggedUser?.user?.rolecode === "CLINIC_ADM") {
//         //     userPayload.account_Id = loggedUser.user.account_Id;
//         //     userPayload.clinic_Id = loggedUser.user.clinic_Id;
//         // }

//         let finalPayload;
//         if (filterVal) {
//             finalPayload = {
//                 ...userPayload,
//                 ...filterVal
//             }
//         }

//         try {
//             const response = await UserService.getUser(filterVal ? finalPayload : userPayload);
//             setUsersList(response.data);
//         }
//         catch (e) {
//             console.log(e);
//         }


//     };

//     const handleSelectAcc = (value) => {
//         if (value) {
//             const selected = accountList.find((clinic) => clinic.account_Id === value);
//             setSelectedAcc(selected);
//         }
//         else {
//             setSelectedAcc(null);
//         }
//     }

//     const handleAccSearch = async (label) => {
//         if (label && label.length >= 2) {
//             const payload = {
//                 account_Name: label
//             }
//             await getAccountList(payload);
//         }
//         else {
//             await getAccountList(null);
//         }
//     }

//     const handleSelectClinic = (value) => {
//         if (value) {
//             const selected = clinicList.find((clinic) => clinic.clinic_Id === value);
//             setSelectedClinic(selected);
//         }
//         else {
//             setSelectedClinic(null);
//         }
//     }

//     const handleClinicSearch = async (label) => {
//         if (label && label.length >= 2) {
//             const payload = {
//                 clinic_Name: label,
//             }
//             fetchClinicList(payload);
//         }
//         else {
//             fetchClinicList(null);
//         }
//     }

//     const fetchClinicList = async (filterVal) => {
//         const payload = {
//             account_Id: selectedAcc.account_Id,
//             status: 1
//         }

//         let finalPayload;
//         if (filterVal) {
//             finalPayload = {
//                 ...payload,
//                 ...filterVal
//             }
//         }

//         try {
//             const response = await ClinicService.getClinicList(filterVal ? finalPayload : payload);
//             setClinicList(response.data);
//             if (loggedUser?.user?.rolecode === "CLINIC_ADM") {
//                 const userClinic = response.data.find((item) => item.clinic_Id === loggedUser?.user?.clinic_Id);
//                 setSelectedClinic(userClinic);
//             }
//         }
//         catch (e) {
//             console.log(e);
//         }
//     }

//     const fetchSpecificClinic = async (filterVal) => {
//         const payload = {
//             status: 1
//         }

//         let finalPayload;
//         if (filterVal) {
//             finalPayload = {
//                 ...payload,
//                 ...filterVal
//             }
//         }

//         try {
//             const response = await ClinicService.getClinicList(filterVal ? finalPayload : payload);
//             setClinicList(response.data);
//             // if (loggedUser?.user?.rolecode === "CLINIC_ADM") {
//             //     const userClinic = response.data.find((item) => item.clinic_Id === loggedUser?.user?.clinic_Id);
//             //     setSelectedClinic(userClinic);
//             // }
//         }
//         catch (e) {
//             console.log(e);
//         }
//     }


//     const handleProviderDetailSave = () => {
//         const { hospitalId, locationId, userId, uhId } = formRef.current.getFieldValue();
//         if (!hospitalId || !locationId || !userId) {
//             handleNext();
//             return
//         }

//         if (selectedEditPatient) {
//             const isHospitalChanged = selectedEditPatient.hospitalId !== hospitalId;
//             const isLocationChanged = selectedEditPatient.locationId !== locationId;
//             const isProviderChanged = selectedEditPatient.providerCode !== userId;

//             const payload = {
//                 ...registrationPayload,
//                 ...(isHospitalChanged && {
//                     hospitalId,
//                     hospitalName: selectedAcc.account_Name,
//                 }),
//                 ...(isLocationChanged && {
//                     locationId,
//                     locationName: selectedClinic.clinic_Name,
//                 }),
//                 ...(isProviderChanged && {
//                     providerCode: userId,
//                     providerName: `${selectedDoc?.firstName} ${selectedDoc?.lastName}`,
//                 }),

//                 modifiedBy: loggedUser?.user?.userId,
//                 modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
//             };

//             dispatch(handleSetPatientRegistrationPayload(payload));
//             handleNext();
//         }
//         else {
//             const payload = {
//                 ...registrationPayload,
//                 hospitalId,
//                 hospitalName: selectedAcc.account_Name,
//                 locationId,
//                 locationName: selectedClinic.clinic_Name,
//                 modifiedBy: loggedUser?.user?.userId,
//                 modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
//                 uhId,
//                 userId,
//                 providerName: selectedDoc?.firstName + ' ' + selectedDoc?.lastName,
//                 providerCode: userId,
//             }

//             dispatch(handleSetPatientRegistrationPayload(payload));
//             handleNext();
//         }


//     }

//     const handleDocChange = (value) => {
//         if(!value) return;
//         setSelectedDoc(usersList.find((item) => item.userId === value));
//     }

//     const handleDocSearch = async (label) => {
//     if (label && label.length >= 2) {
//       const payload = {
//         userName: label
//       }
//       await debouncedGetUsers(payload);
//     }
//     else {
//       await debouncedGetUsers(null);
//     }
//   }


//     // return (
//     //     <div>
//     //         <Form className="w-full grid md:grid-cols-4 grid-cols-1 md:justify-center  md:items-center"
//     //             ref={formRef}
//     //         >

//     //             <div className="">
//     //                 <div className="">
//     //                     <div className="">
//     //                         <label className="md:text-xl text-base font-medium ">
//     //                             Hospital/Medical Practice
//     //                             <span className="text-red-500">*</span>
//     //                         </label>
//     //                     </div>
//     //                     <Form.Item
//     //                         className="md:w-4/5 w-[inherit]"
//     //                         name='hospitalId'
//     //                     >
//     //                         <Select
//     //                             placeholder="Select Hospital"
//     //                             className="md:h-8 h-8 outline-none border-2 rounded-lg"
//     //                             showSearch
//     //                             allowClear
//     //                             onChange={handleSelectAcc}
//     //                             onSearch={handleAccSearch}
//     //                             options={accountList?.map((acc, idx) => {
//     //                                 return {
//     //                                     label: acc.account_Name,
//     //                                     value: acc.account_Id,
//     //                                     key: idx
//     //                                 }
//     //                             })}
//     //                             filterOption={(input, option) =>
//     //                                 option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
//     //                             }
//     //                             dropdownStyle={{ width: '15rem' }}
//     //                         />
//     //                     </Form.Item>
//     //                 </div>
//     //             </div>

//     //             <div>
//     //                 <div className="">
//     //                     <div className="">
//     //                         <label className="md:text-xl text-base font-medium ">
//     //                             Location
//     //                             <span className="text-red-500">*</span>
//     //                         </label>
//     //                     </div>
//     //                     <Form.Item
//     //                         className="md:w-4/5 w-[inherit]"
//     //                         name='locationId'
//     //                     >
//     //                         <Select
//     //                             placeholder="Branch"
//     //                             className="md:h-8 h-8 outline-none border-2 rounded-lg"
//     //                             onChange={handleSelectClinic}
//     //                             onSearch={handleClinicSearch}
//     //                             options={clinicList.map((clinic, idx) => {
//     //                                 return {
//     //                                     label: clinic.clinic_Name,
//     //                                     value: clinic.clinic_Id,
//     //                                     key: idx
//     //                                 }
//     //                             })}
//     //                             showSearch
//     //                             allowClear
//     //                             filterOption={(input, option) => (
//     //                                 option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
//     //                             )}
//     //                         />
//     //                     </Form.Item>
//     //                 </div>
//     //             </div>


//     //             <div className="">
//     //                 <div className="">
//     //                     <div className="">
//     //                         <label className="md:text-xl text-base font-medium ">
//     //                             Provider
//     //                             <span className="text-red-500">*</span>
//     //                         </label>
//     //                     </div>
//     //                     <Form.Item
//     //                         className="md:w-4/5 w-[inherit]"
//     //                         name='userId'
//     //                     >
//     //                         <Select
//     //                             placeholder="Select Doctor"
//     //                             className="md:h-8 h-8 outline-none border-2 rounded-lg"
//     //                             showSearch
//     //                             allowClear
//     //                             onChange={handleDocChange}
//     //                             options={usersList?.map((user, idx) => {
//     //                                 return {
//     //                                     label: `${user.firstName} ${user.lastName}`,
//     //                                     value: user.userId,
//     //                                     key: idx
//     //                                 }
//     //                             })}
//     //                             filterOption={(input, option) =>
//     //                                 option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
//     //                             }
//     //                         />
//     //                     </Form.Item>
//     //                 </div>
//     //             </div>

//     //             <div className="">
//     //                 <div className="">
//     //                     <div className="">
//     //                         <label className="md:text-lg text-base font-medium">
//     //                             UHID
//     //                         </label>
//     //                     </div>
//     //                     <Form.Item name="uhId">
//     //                         <Input
//     //                             placeholder="Enter uhid"
//     //                             name="uhid"
//     //                             className="md:w-4/5 w-full  md:h-8 h-8 outline-none border-2 p-2 rounded-lg"
//     //                         />
//     //                     </Form.Item>
//     //                 </div>
//     //             </div>
//     //         </Form>
//     //         <div className="flex md:flex-row text-center flex-col md:items-center items-end justify-end gap-3 ">
//     //             <button
//     //                 disabled={currPageView === 1}
//     //                 className={`${currPageView > 1 ? 'block' : 'hidden'} md:min-w-24 w-[3rem]  md:w-24  h-8 p-1 custom_filter text-brand-White rounded-lg font-semibold disabled:cursor-not-allowed disabled:opacity-50`}
//     //                 onClick={handlePrevious}
//     //             >
//     //                 Previous
//     //             </button>
//     //             <button
//     //                 className="md:min-w-24 w-[3rem] md:w-24  h-8 p-1 bg-brand-White rounded-lg border text-brand-primaryColor border-brand-primaryColor font-semibold custom-button-shadow"
//     //                 onClick={handleCancel}
//     //             >
//     //                 Cancel
//     //             </button>
//     //             <button
//     //                 className="md:min-w-24 w-[3rem]  md:w-24  h-8 p-1 custom_filter text-brand-White rounded-lg font-semibold disabled:cursor-not-allowed disabled:opacity-50"
//     //                 onClick={handleProviderDetailSave}
//     //             >
//     //                 Next
//     //             </button>
//     //         </div>
//     //     </div>
//     // )
//     return (
//         <div>
//             <Form
//                 className="w-full grid md:grid-cols-3 grid-cols-1 md:justify-center md:items-center"
//                 ref={formRef}
//             >
//                 <div className="relative mt-3 md:w-4/5 w-full">
//                     <span className="absolute -top-1 left-3 bg-white px-1 z-10 text-[#A0A2A3] text-xs">
//                         Hospital/Medical Practice <span className="text-red-500">*</span>
//                     </span>

//                     <Form.Item name="hospitalId" className="mt-1">
//                         <Select
//                             placeholder="Select Hospital"
//                             className="rounded-md h-10"
//                             showSearch
//                             allowClear
//                             onChange={handleSelectAcc}
//                             options={accountList?.map((acc, idx) => ({
//                                 label: acc.account_Name,
//                                 value: acc.account_Id,
//                                 key: idx,
//                             }))}
//                             filterOption={(input, option) =>
//                                 option.label.toLowerCase().includes(input.toLowerCase())
//                             }
//                             dropdownStyle={{ width: "15rem" }}
//                         />
//                     </Form.Item>
//                 </div>

//                 <div className="relative mt-3 md:w-4/5 w-full">
//                     <span className="absolute -top-1 left-3 bg-white px-1 z-10 text-[#A0A2A3] text-xs">
//                         Location <span className="text-red-500">*</span>
//                     </span>

//                     <Form.Item name="locationId" className="mt-1">
//                         <Select
//                             placeholder="Branch"
//                             className="rounded-md h-10"
//                             onChange={handleSelectClinic}
//                             onSearch={handleClinicSearch}
//                             showSearch
//                             allowClear
//                             options={clinicList.map((clinic, idx) => ({
//                                 label: clinic.clinic_Name,
//                                 value: clinic.clinic_Id,
//                                 key: idx,
//                             }))}
//                             filterOption={(input, option) =>
//                                 option.label.toLowerCase().includes(input.toLowerCase())
//                             }
//                         />
//                     </Form.Item>
//                 </div>

//                 <div className="relative mt-3 md:w-4/5 w-full">
//                     <span className="absolute -top-1 left-3 bg-white px-1 z-10 text-[#A0A2A3] text-xs">
//                         Provider <span className="text-red-500">*</span>
//                     </span>

//                     <Form.Item name="userId" className="mt-1">
//                         <Select
//                             placeholder="Select Doctor"
//                             className="rounded-md h-10"
//                             showSearch
//                             allowClear
//                             onSearch={handleDocSearch}
//                             onChange={handleDocChange}
//                             options={usersList?.map((user, idx) => ({
//                                 label: `${user.firstName} ${user.lastName}`,
//                                 value: user.userId,
//                                 key: idx,
//                             }))}
//                             filterOption={false}
//                         />
//                     </Form.Item>
//                 </div>

//                 <div className="relative mt-3 md:w-4/5 w-full">
//                     <span className="absolute -top-1 left-3 bg-white px-1 z-10 text-[#A0A2A3] text-xs">
//                         UHID
//                     </span>

//                     <Form.Item name="uhId" className="mt-1">
//                         <Input
//                             placeholder="Enter uhid"
//                             className="w-full h-10 outline-none border-2 rounded-md px-2"
//                         />
//                     </Form.Item>
//                 </div>
//             </Form>

//             <div className="flex md:flex-row text-center flex-col md:items-center items-end justify-end gap-3 ">
//                 <button
//                     disabled={currPageView === 1}
//                     className={`${currPageView > 1 ? "block" : "hidden"
//                         } md:min-w-24 w-[3rem]  md:w-24  h-8 p-1 custom_filter text-brand-White rounded-lg font-semibold disabled:cursor-not-allowed disabled:opacity-50`}
//                     onClick={handlePrevious}
//                 >
//                     Previous
//                 </button>
//                 <button
//                     className="md:min-w-24 w-[3rem] md:w-24  h-8 p-1 bg-white rounded-lg border  border-brand-primaryColor text-brand-primaryColor font-semibold custom-button-shadow"
//                     onClick={handleCancel}
//                 >
//                     Cancel
//                 </button>
//                 <button
//                     className="md:min-w-24 w-[3rem]  md:w-24  h-8 p-1 custom_filter text-brand-White rounded-lg font-semibold disabled:cursor-not-allowed disabled:opacity-50"
//                     onClick={handleProviderDetailSave}
//                 >
//                     Next
//                 </button>
//             </div>
//         </div>
//     );
// }

// export default RpmDetails

import { Form, Input, Select } from 'antd';
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import AccountService from '../../../../../Services/AccountService';
import UserService from '../../../../../Services/UserService';
import ClinicService from '../../../../../Services/ClinicService';
import { convertUTCDate } from '../../../../../utils/convertionFunc';
import { useDispatch, useSelector } from 'react-redux';
import { handleSetPatientRegistrationPayload } from '../../../../../Redux/actions/patientActions';
import { debounce } from 'lodash';

function RpmDetails({ handleCancel, handleNext, handlePrevious, currPageView, isRpmEnabled }, ref) {
    const [usersList,     setUsersList]     = useState([]);
    const [accountList,   setAccountList]   = useState([]);
    const [clinicList,    setClinicList]    = useState([]);
    const [selectedClinic, setSelectedClinic] = useState(null);
    const [selectedAcc,   setSelectedAcc]   = useState(null);
    const [selectedDoc,   setSelectedDoc]   = useState(null);
    const formRef   = useRef();
    const dispatch  = useDispatch();
    const { registrationPayload, selectedEditPatient } = useSelector((s) => s.patients);
    const loggedUserObj = sessionStorage.getItem('login_result');
    const loggedUser    = loggedUserObj ? JSON.parse(loggedUserObj) : null;

    const debouncedGetUsers = useRef(
        debounce((payload) => getUsersList(payload), 300)
    ).current;

    // ── Expose collectValues ──────────────────────────────────────────────────

    useImperativeHandle(ref, () => ({
        collectValues: () => {
            if (!formRef.current) return;
            const { hospitalId, locationId, providerCode, uhId } = formRef.current.getFieldsValue();
            if (!hospitalId && !locationId && !providerCode) return; // nothing filled, skip

            const payload = {
                ...registrationPayload,
                ...(hospitalId && { hospitalId, hospitalName: selectedAcc?.account_Name }),
                ...(locationId && { locationId, locationName: selectedClinic?.clinic_Name }),
                ...(providerCode     && { providerCode: providerCode, providerName: selectedDoc?.userName ? selectedDoc.userName : registrationPayload?.providerName }),
                ...(uhId       && { uhId }),
                modifiedBy:   loggedUser?.user?.userId,
                modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
            };
            dispatch(handleSetPatientRegistrationPayload(payload));
        }
    }));

    // ── Effects (unchanged) ───────────────────────────────────────────────────

    useEffect(() => {
        if (selectedEditPatient && !selectedAcc && !selectedClinic) {
            if (selectedEditPatient.hospitalId) {
                setSelectedAcc({ account_Id: selectedEditPatient.hospitalId });
                getSpecificAccount({ account_Id: selectedEditPatient.hospitalId });
            }
            if (selectedEditPatient.hospitalId && selectedEditPatient.locationId) {
                fetchSpecificClinic({ account_Id: selectedEditPatient.hospitalId, clinic_Id: selectedEditPatient.locationId });
                setSelectedClinic({ account_Id: selectedEditPatient.hospitalId, clinic_Id: selectedEditPatient.locationId });
                if (selectedEditPatient.providerCode) {
                    fetchSpecificUser({ account_Id: selectedEditPatient.hospitalId, clinic_Id: selectedEditPatient.locationId, userId: selectedEditPatient?.providerCode });
                    setSelectedDoc({ account_Id: selectedClinic?.account_Id, clinic_Id: selectedClinic?.clinic_Id, providerName: selectedEditPatient?.providerName,providerCode: selectedEditPatient?.providerCode});
                }
            }
            formRef.current?.setFieldsValue({
                hospitalId: selectedEditPatient.hospitalId,
                locationId: selectedEditPatient.locationId,
                providerCode:     selectedEditPatient.providerCode,
                uhId:       selectedEditPatient.uhId
            });
        }
    }, [selectedEditPatient]);

    useEffect(() => { getAccountList(null); }, []);
    useEffect(() => { if (selectedAcc) fetchClinicList(); }, [selectedAcc]);
    useEffect(() => { if (selectedAcc && selectedClinic) getUsersList({ account_Id: selectedAcc.account_Id, clinic_Id: selectedClinic.clinic_Id }); }, [selectedAcc, selectedClinic]);

    // ── API helpers (unchanged) ───────────────────────────────────────────────

    const getAccountList = async (filterPayload) => {
        let payload = { pageNo: 1, accountRoleType: 'clinic' };
        if (loggedUser?.user?.rolecode === "ACCT_ADM" || loggedUser?.user?.rolecode === "CLINIC_ADM") payload.account_Id = loggedUser?.user?.account_Id;
        const finalPayload = filterPayload ? { ...payload, ...filterPayload } : payload;
        try {
            const response = await AccountService.AccountList(finalPayload);
            setAccountList(response.data);
            if (loggedUser?.user?.rolecode === "ACCT_ADM" || loggedUser?.user?.rolecode === "CLINIC_ADM") setSelectedAcc(response.data[0]);
        } catch (e) { console.log(e); }
    };

    const getSpecificAccount = async (filterPayload) => {
        const payload = { pageNo: 1, accountRoleType: 'clinic', ...filterPayload };
        try {
            const response = await AccountService.AccountList(payload);
            setAccountList(response.data);
            if (loggedUser?.user?.rolecode === "ACCT_ADM" || loggedUser?.user?.rolecode === "CLINIC_ADM") setSelectedAcc(response.data[0]);
        } catch (e) { console.log(e); }
    };

    const getUsersList = async (filterVal) => {
        const userPayload = { pageNo: '1', userType: 'P' };
        if (loggedUser?.user?.rolecode === "ACCT_ADM") userPayload.account_Id = loggedUser.user.account_Id;
        if (loggedUser?.user?.rolecode === "CLINIC_ADM") { userPayload.account_Id = loggedUser.user.account_Id; userPayload.clinic_Id = loggedUser.user.clinic_Id; }
        const finalPayload = filterVal ? { ...userPayload, ...filterVal } : userPayload;
        try {
            const response = await UserService.getUser(finalPayload);
            setUsersList(response.data);
        } catch (e) { console.log(e); }
    };

    const fetchSpecificUser = async (filterVal) => {
        const finalPayload = filterVal ? { pageNo: '1', ...filterVal } : { pageNo: '1' };
        try {
            const response = await UserService.getUser(finalPayload);
            setUsersList(response.data);
        } catch (e) { console.log(e); }
    };

    const fetchClinicList = async (filterVal) => {
        const payload = { account_Id: selectedAcc.account_Id, status: 1 };
        const finalPayload = filterVal ? { ...payload, ...filterVal } : payload;
        try {
            const response = await ClinicService.getClinicList(finalPayload);
            setClinicList(response.data);
            if (loggedUser?.user?.rolecode === "CLINIC_ADM") {
                const userClinic = response.data.find((item) => item.clinic_Id === loggedUser?.user?.clinic_Id);
                setSelectedClinic(userClinic);
            }
        } catch (e) { console.log(e); }
    };

    const fetchSpecificClinic = async (filterVal) => {
        const finalPayload = filterVal ? { status: 1, ...filterVal } : { status: 1 };
        try {
            const response = await ClinicService.getClinicList(finalPayload);
            setClinicList(response.data);
        } catch (e) { console.log(e); }
    };

    const handleSelectAcc    = (value) => { if (value) setSelectedAcc(accountList.find((a) => a.account_Id === value)); else setSelectedAcc(null); };
    const handleAccSearch    = (label) => { label?.length >= 2 ? getAccountList({ account_Name: label }) : getAccountList(null); };
    const handleSelectClinic = (value) => { if (value) setSelectedClinic(clinicList.find((c) => c.clinic_Id === value)); else setSelectedClinic(null); };
    const handleClinicSearch = (label) => { label?.length >= 2 ? fetchClinicList({ clinic_Name: label }) : fetchClinicList(null); };
    const handleDocChange    = (value) => { if (!value) return; setSelectedDoc(usersList.find((u) => u.userId === value)); };
    const handleDocSearch    = (label) => { label?.length >= 2 ? debouncedGetUsers({ userName: label }) : debouncedGetUsers(null); };

    // ── handleProviderDetailSave — collect + next (no blocking validation) ────

    const handleProviderDetailSave = () => {
        if (ref?.current?.collectValues) ref.current.collectValues();
        handleNext();
    };

    return (
        <div>
            <Form disabled={!isRpmEnabled} className="w-full grid md:grid-cols-3 grid-cols-1 md:justify-center md:items-center" ref={formRef}>
                <div className="relative mt-3 md:w-4/5 w-full">
                    <span className="absolute -top-1 left-3 bg-white px-1 z-10 text-[#A0A2A3] text-xs">Hospital/Medical Practice <span className="text-red-500">*</span></span>
                    <Form.Item name="hospitalId" className="mt-1">
                        <Select placeholder="Select Hospital" className="rounded-md h-10" showSearch allowClear onChange={handleSelectAcc} onSearch={handleAccSearch}
                            options={accountList?.map((acc, idx) => ({ label: acc.account_Name, value: acc.account_Id, key: idx }))}
                            filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())} dropdownStyle={{ width: "15rem" }} />
                    </Form.Item>
                </div>
                <div className="relative mt-3 md:w-4/5 w-full">
                    <span className="absolute -top-1 left-3 bg-white px-1 z-10 text-[#A0A2A3] text-xs">Location <span className="text-red-500">*</span></span>
                    <Form.Item name="locationId" className="mt-1">
                        <Select placeholder="Branch" className="rounded-md h-10" onChange={handleSelectClinic} onSearch={handleClinicSearch} showSearch allowClear
                            options={clinicList.map((clinic, idx) => ({ label: clinic.clinic_Name, value: clinic.clinic_Id, key: idx }))}
                            filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())} />
                    </Form.Item>
                </div>
                <div className="relative mt-3 md:w-4/5 w-full">
                    <span className="absolute -top-1 left-3 bg-white px-1 z-10 text-[#A0A2A3] text-xs">Provider <span className="text-red-500">*</span></span>
                    <Form.Item name="providerCode" className="mt-1">
                        <Select placeholder="Select Doctor" className="rounded-md h-10" showSearch allowClear onSearch={handleDocSearch} onChange={handleDocChange}
                            options={usersList?.map((user, idx) => ({ label: `${user.firstName} ${user.lastName}`, value: user.userId, key: idx }))}
                            filterOption={false} />
                    </Form.Item>
                </div>
                <div className="relative mt-3 md:w-4/5 w-full">
                    <span className="absolute -top-1 left-3 bg-white px-1 z-10 text-[#A0A2A3] text-xs">UHID</span>
                    <Form.Item name="uhId" className="mt-1">
                        <Input placeholder="Enter uhid" className="w-full h-10 outline-none border-2 rounded-md px-2" />
                    </Form.Item>
                </div>
            </Form>
            <div className="flex md:flex-row text-center flex-col md:items-center items-end justify-end gap-3">
                <button className={`${currPageView > 1 ? "block" : "hidden"} md:min-w-24 w-[3rem] md:w-24 h-8 p-1 custom_filter text-white rounded-lg font-semibold disabled:cursor-not-allowed disabled:opacity-50`} disabled={!isRpmEnabled} onClick={handlePrevious}>Previous</button>
                <button className="md:min-w-24 w-[3rem] md:w-24 h-8 p-1 bg-white rounded-lg border border-brand-primaryColor text-brand-primaryColor font-semibold custom-button-shadow" onClick={handleCancel}>Cancel</button>
                <button className="md:min-w-24 w-[3rem] md:w-24 h-8 p-1 custom_filter text-white rounded-lg font-semibold disabled:cursor-not-allowed disabled:opacity-50" disabled={!isRpmEnabled} onClick={handleProviderDetailSave}>Next</button>
            </div>
        </div>
    );
}

export default forwardRef(RpmDetails);